export const slides = [
  // Commented out for reference
  // {
  //   type: 'video',
  //   video: `${process.env.PUBLIC_URL}/assets/video/mh002.mp4`,
  //   title: 'slideTitle0',
  //   defaultTitle: 'Mediahuis Tariefcalculator',
  //   subtitle: 'slideSubtitle0',
  //   defaultSubtitle: 'Discover our comprehensive media offerings',
  // },
  {
    type: 'image',
    image: `${process.env.PUBLIC_URL}/assets/productvisuals/Mediahuis-culy-first-person.jpg`,
    alignment: 'center center',
    title: 'slideTitle1',
    defaultTitle: 'Digital Advertising Solutions',
    subtitle: 'slideSubtitle1',
    defaultSubtitle: 'Reach your target audience with our premium digital platforms',
  },
  {
    type: 'image',
    image: `${process.env.PUBLIC_URL}/assets/productvisuals/SLAM.jpg`,
    alignment: 'center top',
    title: 'slideTitle2',
    defaultTitle: 'Audio & Radio Campaigns',
    subtitle: 'slideSubtitle2',
    defaultSubtitle: 'Connect with listeners through our popular radio stations',
  },
  {
    type: 'image',
    image: `${process.env.PUBLIC_URL}/assets/productvisuals/Dagblad-van-het-Noorden-mobile-scaled.jpeg`,
    alignment: 'center center',
    title: 'slideTitle3',
    defaultTitle: 'Mobile Advertising',
    subtitle: 'slideSubtitle3',
    defaultSubtitle: 'Engage with users on the go with our mobile advertising options',
  },
  {
    type: 'image',
    image: `${process.env.PUBLIC_URL}/assets/productvisuals/Mediah3okt0067.jpg`,
    alignment: 'center center',
    title: 'slideTitle4',
    defaultTitle: 'Integrated Media Campaigns',
    subtitle: 'slideSubtitle4',
    defaultSubtitle: 'Combine multiple channels for maximum impact',
  },
  {
    type: 'image',
    image: `${process.env.PUBLIC_URL}/assets/productvisuals/Limburger-2-beelden-1.webp`,
    alignment: 'center center',
    title: 'slideTitle5',
    defaultTitle: 'Regional Print Media',
    subtitle: 'slideSubtitle5',
    defaultSubtitle: 'Target specific regions with our trusted local newspapers',
  }
  
]; 